import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import React, { memo, useMemo, useRef } from "react";
import Link from "next/link";
import lIsEqual from "lodash.isequal";
import { VideoStatus } from "@parkschannel/contracts";
import { ShareVideo } from "../../Video/ShareVideo";
import { useCurrentUserVideos } from "../hooks";
import { errorToast, successToast } from "../../Toast";
import { useAuth } from "../../Auth/AuthContext";
import { confirm, DeleteOutlineIcon, Dropdown, EditOutlineIcon, MoreOutlineIcon, ShareIcon } from "@parkschannel/ui";
export const UserVideoCardDropdown = /*#__PURE__*/ memo((param)=>{
    let { data  } = param;
    const shareVideoRef = useRef(null);
    const { useDeleteUserVideoMutationQuery  } = useCurrentUserVideos();
    const deleteUserVideo = useDeleteUserVideoMutationQuery();
    const deleteVideo = async ()=>{
        try {
            await deleteUserVideo.mutateAsync({
                videoId: data.id
            });
            successToast({
                description: "Video has been removed!"
            });
        } catch (err) {
            errorToast({
                description: "Ops! Something went wrong"
            });
        }
    };
    const handleDelete = ()=>{
        confirm({
            onConfirm: deleteVideo,
            title: "Confirmation",
            children: /*#__PURE__*/ _jsx("p", {
                children: "Are you sure you want to delete this video?"
            })
        });
    };
    const waitingForApprovalActions = useMemo(()=>[
            /*#__PURE__*/ _jsx(DeleteVideoButton, {
                onClick: handleDelete,
                authorId: data.author.cognito_id
            })
        ], [
        data.status
    ]);
    const draftActions = useMemo(()=>[
            /*#__PURE__*/ _jsx(Link, {
                href: "/videos/".concat(data.id),
                children: /*#__PURE__*/ _jsxs(UserDropdownMenuItem, {
                    children: [
                        /*#__PURE__*/ _jsx(EditOutlineIcon, {}),
                        " ",
                        /*#__PURE__*/ _jsx("span", {
                            children: "Edit"
                        })
                    ]
                })
            }),
            ...waitingForApprovalActions
        ], [
        data.status
    ]);
    const publishedActions = useMemo(()=>[
            /*#__PURE__*/ _jsxs(UserDropdownMenuItem, {
                onClick: ()=>{
                    if (shareVideoRef.current) {
                        shareVideoRef.current.click();
                    }
                },
                children: [
                    /*#__PURE__*/ _jsx(ShareIcon, {}),
                    " ",
                    /*#__PURE__*/ _jsx("span", {
                        children: "Share"
                    })
                ]
            }),
            ...waitingForApprovalActions
        ], [
        data.status
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Dropdown, {
                menuItems: data.status === VideoStatus.PUBLISHED ? publishedActions : data.status === VideoStatus.DRAFT ? draftActions : waitingForApprovalActions,
                children: /*#__PURE__*/ _jsx("div", {
                    className: classNames("text-white w-[40px] h-[40px] rounded-full bg-white/25 backdrop-blur-[2px] flex justify-center items-center hover:backdrop-blur-sm"),
                    children: /*#__PURE__*/ _jsx(MoreOutlineIcon, {})
                })
            }),
            /*#__PURE__*/ _jsx(ShareVideo, {
                video: data,
                children: /*#__PURE__*/ _jsx("span", {
                    ref: shareVideoRef,
                    className: "hidden",
                    children: "share"
                })
            })
        ]
    });
}, isEqual);
function isEqual(prevProps, nextProps) {
    return lIsEqual(prevProps, nextProps);
}
const UserDropdownMenuItem = (param)=>{
    let { children , onClick  } = param;
    return /*#__PURE__*/ _jsx("button", {
        onClick: onClick,
        className: "w-full flex gap-1 items-center py-2 px-3 text-neutral-500 text-xs hover:bg-neutral-50",
        children: children
    });
};
const DeleteVideoButton = (param)=>{
    let { onClick , authorId  } = param;
    const { useSession  } = useAuth();
    const session = useSession();
    if (!session.data || !session.data.user || session.data.user.cognito_id !== authorId) return null;
    return /*#__PURE__*/ _jsxs(UserDropdownMenuItem, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ _jsx(DeleteOutlineIcon, {}),
            " ",
            /*#__PURE__*/ _jsx("span", {
                children: "Delete"
            })
        ]
    });
};
